const PASSWORD_MIGRATION_SIGNAL_PREFIX = "afrimed:password-migration:secure-link:";
const CREATE_PASSWORD_NUDGE_PREFIX = "afrimed:create-password:nudge:";

function getUserId(userOrId) {
  return String(typeof userOrId === "string" ? userOrId : userOrId?.id || "").trim();
}

export function getPasswordMigrationSignalKey(userOrId) {
  const userId = getUserId(userOrId);
  return userId ? `${PASSWORD_MIGRATION_SIGNAL_PREFIX}${userId}` : "";
}

export function markSecureLinkPasswordMigration(user) {
  if (typeof window === "undefined") return;
  const key = getPasswordMigrationSignalKey(user);
  if (!key) return;
  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({
        userId: getUserId(user),
        email: String(user?.email || "").trim().toLowerCase(),
        createdAt: new Date().toISOString(),
        source: "secure-link",
      }),
    );
  } catch {
    // ignore local storage failures
  }
}

export function hasPasswordMigrationSignal(user) {
  if (typeof window === "undefined") return false;
  const key = getPasswordMigrationSignalKey(user);
  if (!key) return false;
  try {
    return !!window.localStorage.getItem(key);
  } catch {
    return false;
  }
}

export function clearPasswordMigrationSignal(userOrId) {
  if (typeof window === "undefined") return;
  const userId = getUserId(userOrId);
  if (!userId) return;
  try {
    window.localStorage.removeItem(`${PASSWORD_MIGRATION_SIGNAL_PREFIX}${userId}`);
    window.localStorage.removeItem(`${CREATE_PASSWORD_NUDGE_PREFIX}${userId}`);
  } catch {
    // ignore local storage failures
  }
}

export function hasPasswordConfigured(user) {
  const meta = user?.user_metadata || {};
  return meta.password_set === true || !!String(meta.password_changed_at || "").trim();
}

export function shouldOfferCreatePassword(user) {
  if (hasPasswordConfigured(user)) return false;
  return true;
}

export function requiresPasswordBeforePasscode(user) {
  return shouldOfferCreatePassword(user);
}

export function hasPasscodeConfigured(profile) {
  return !!(
    profile?.passcode_set_at ||
    profile?.passcode_updated_at ||
    profile?.passcode_hash ||
    profile?.passcode
  );
}

export function resolveSettingsRole(profile, pathname = "") {
  const path = String(pathname || "");
  if (path.startsWith("/settings/doctor")) return "doctor";
  if (path.startsWith("/settings/patient")) return "patient";
  return profile?.role === "doctor" ? "doctor" : "patient";
}

export function getLoginSecurityBasePath(profile, pathname = "") {
  return `/settings/${resolveSettingsRole(profile, pathname)}/login-security`;
}

export function getProfileTableForSecurity(profile, pathname = "") {
  return resolveSettingsRole(profile, pathname) === "doctor"
    ? "doctor_profiles"
    : "patient_profiles";
}
